import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const PLATFORM_MAINTENANCE_PATH = '/maintenance/platform';

const PlatformMaintenanceGuard = ({ active, authUser, children, userData }) => {
    const location = useLocation();
    const bypass = userData?.bypass_maintenance === true;

    if (active && authUser && !userData) {
        return null;
    }

    if (active && !bypass && location.pathname !== PLATFORM_MAINTENANCE_PATH) {
        return (
            <Navigate
                to={PLATFORM_MAINTENANCE_PATH}
                replace
                state={{ from: location }}
            />
        );
    }

    if (!active && location.pathname === PLATFORM_MAINTENANCE_PATH) {
        return <Navigate to="/" replace />;
    }

    return children;
};

PlatformMaintenanceGuard.propTypes = {
    active: PropTypes.bool,
    authUser: PropTypes.object,
    children: PropTypes.node,
    userData: PropTypes.object
};

const mapStateToProps = ({ auth, platformMaintenance, user }) => ({
    active: platformMaintenance?.active === true,
    authUser: auth.authUser,
    userData: user.userData
});

export default connect(mapStateToProps)(PlatformMaintenanceGuard);
